import { foundationSnackbarStyles } from '@genesislcap/foundation-ui';
import { neutralLayer1, neutralLayer2 } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { chartPinkWebRGBA } from '../_config/styles/colors';
export const zeroSnackbarStyles = css `
  ${foundationSnackbarStyles}
  .snackbar {
    border: calc(var(--stroke-width) * 1px) solid ${neutralLayer2};
    background-color: ${neutralLayer1};
  }

  :host([type='error']) .snackbar::after {
    background-color: ${chartPinkWebRGBA(1)};
  }
`;
